<template>

  <div class="Interactive container-fluid">
    
    <div class="row">
      <div class="col-3 sideBar">
        <div class="row">
          <div class="col">
              <button :class="{btn_visuals: true, selected: showMobileSelected}"  v-on:click="toggleBtn('mobile')" >Mobile</button>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button :class="{btn_visuals:true, selected: showGameSelected}" v-on:click="toggleBtn('game')">Game</button>
            <div class="gameElement" v-if="showGame">
            </div>
          </div>
          
        </div>
      </div>
      <div class="col-9 mainBar">
        <div v-if="showMobile">
          <Mobile></Mobile>
        </div>
        <div v-if="showGame">
          <Game></Game>
        </div>
         <div  class="defaultText" v-if="(showMobile == false && showGame == false)">
          &#60;-- Please select an option
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import Mobile from './Interactive/Mobile'
import Game from './Interactive/Game'

export default {
  name: 'Interactive',
  data: () =>({
    showMobile: true,
    showGame: false,
    showMobileSelected: true,
    showGameSelected: false
  }),
  components:{
    'Mobile': Mobile,
    'Game': Game
  },
  methods:{
    toggleMobileBtn: function(){
      this.showMobile = !this.showMobile

      if(this.showGame){
        this.showGame = !this.showGame
      }
    },
    toggleGameBtn: function(){
      this.showAnimation = !this.showAnimation

      if(this.showComic){
        this.showComic = !this.showComic
      }
    },
    toggleBtn: function(name){
      //reset button selection

      if(name == 'mobile'){
        this.showMobile = !this.showMobile
        if(this.showGame){
          this.showGame = !this.showGame
        }
        //check if now both buttons are false, if yes, reset the change
        if(this.showMobile == this.showGame){
          this.showMobile = !this.showMobile
        }else{
          //css
          this.showMobileSelected = !this.showMobileSelected

          //css
          if(this.showGameSelected){
            this.showGameSelected = !this.showGameSelected
          }


        }
        
      }else{
        this.showGame = !this.showGame
        if(this.showMobile){
          this.showMobile = !this.showMobile
        }
        //check if now both buttons are false, if yes, reset the change
        if(this.showGame == this.showMobile){
          this.showGame = !this.showGame
        }else{
          //css
          this.showGameSelected = !this.showGameSelected

          //css
          if(this.showMobileSelected){
            this.showMobileSelected = !this.showMobileSelected
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

.title{
    text-align:center;
}
.sideBar{

  text-align: center;
  padding-top: 2%;
}

.defaultText{
  margin: 10% 20% 0 20%;
  font-family: 'Roboto', sans-serif;
  font-weight: 550;
}

.btn_visuals{
  font-family: 'Cabin Sketch', cursive;
  font-size: 40px;
  border: none;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px #999;
  margin: 5%;
}

.btn_visuals:active{
  transform: translateY(4px);
  background-color: rgb(0, 0, 0);
  color:white;
}
.btn_visuals:hover{
    transform: scale(1.05);
}
.selected{
  background-color: rgb(0, 0, 0);
  color:white;
}


</style>
